<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0"
        >การจัดการ กลุ่มสิทธิ์</span
      >
      <v-spacer></v-spacer>
      <v-btn
        :disabled="uiCtrl && !uiCtrl.isEnable('btn:::authority:create')"
        color="primary"
        @click="handleAddRightsGroupForm"
      >
        <v-icon small left>mdi-plus</v-icon>เพิ่มกลุ่มสิทธิ์
      </v-btn>
    </div>
    <v-card outlined>
      <v-row align="center" class="ma-0">
        <v-col md="3" lg="3" xl="2">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            dense
            outlined
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="rightsGroup"
      :custom-filter="customFilter"
      :items-per-page="10"
      class="elevation-1 mt-3"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
      <template v-slot:item.timezone="{ item }">
        {{ item.timezone.timezone_code }} - {{ item.timezone.title_th }}
      </template>
      <template v-slot:item.hardware_group="{ item }">
        {{ item.hardware_group.title_th }}
      </template>
      <template v-slot:item.employee_group="{ item }">
        {{ item.employee_group.title_th }}
      </template>
      <template v-slot:item.access_control_start_time="{ item }">
        <div v-if="item.timezone && item.timezone.timezone_code === 'TA'">
          --
        </div>
        <div v-else>
          {{ item.access_control_start_time | dateFormat }}
        </div>
      </template>
      <template v-slot:item.access_control_end_time="{ item }">
        <div v-if="item.timezone && item.timezone.timezone_code === 'TA'">
          --
        </div>
        <div v-else>
          {{ item.access_control_end_time | dateFormat }}
        </div>
      </template>
    </v-data-table>
    <RightGroupForm
      :formShow="rightGroupFormShow"
      :formAction="rightGroupFormAction"
      :rightGroup="rightGroup"
      :rightGroupInit="rightGroupInit"
      @isRightGroupDataChange="handleRightGroupFormDataChange"
      @formActionCompleted="handleRightGroupFormActionCompleted"
      @onReset="handleRightGroupFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="rightGroupFormShow && rightGroupFormAction === 'add'"
      z-index="0"
    ></v-overlay>
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import RightGroupForm from '@/views/rights-group/RightGroupForm.vue'

export default {
  components: {
    RightGroupForm,
    ConfirmDialog,
  },
  data() {
    return {
      dialogForbidden: false,
      sortBy: ['authority_code'],
      sortDesc: [false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: false,
      search: '',
      rightGroupFormShow: false,
      rightGroupFormAction: '',
      rightGroup: {},
      rightGroupInit: {},
      isRightGroupDataChange: false,
      timeout: null,
    }
  },
  filters: {
    dateFormat: function (value) {
      if (!value) return
      return moment.utc(value).format('DD/MM/YYYY')
    },
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    headers() {
      return [
        { text: 'รหัสกลุ่มสิทธิ์', align: 'start', value: 'authority_code' },
        { text: 'คำอธิบาย (ไทย)', align: 'start', value: 'title_th' },
        { text: 'รหัสช่วงเวลา', align: 'start', value: 'timezone' },
        { text: 'กลุ่ม Device', align: 'start', value: 'hardware_group' },
        {
          text: 'จำนวน Device',
          align: 'start',
          value: 'hardware_group.total_hardware',
        },
        { text: 'กลุ่ม พนักงาน', align: 'start', value: 'employee_group' },
        {
          text: 'จำนวน พนักงาน',
          align: 'start',
          value: 'employee_group.total_employee',
        },
        {
          text: 'วันเริ่มใช้งาน',
          align: 'start',
          value: 'access_control_start_time',
        },
        {
          text: 'วันสิ้นสุดใช้งาน',
          align: 'start',
          value: 'access_control_end_time',
        },
      ]
    },
    rightsGroup() {
      return this.$store.state.rightsGroup.rightsGroup
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'การจัดการ กลุ่มสิทธิ์',
        disabled: true,
      },
    ])

    const { company_uuid } = this.$store.state.authentication.company

    this.loading = true

    Promise.all([
      this.fetchRightsGroup({ company_uuid }),
      this.fetchHardwaresGroup({
        company_uuid,
        params: {
          dpc: 'access-authority-to-list-access-hardware-group',
        },
      }),
      this.fetchEmployeesGroup({
        company_uuid,
        params: {
          dpc: 'access-authority-to-list-access-employee-group',
        },
      }),
      this.fetchTimezones({
        company_uuid,
        params: {
          dpc: 'access-authority-to-list-timezone',
          is_display_time_attendance: true,
        },
      }),
    ])
      .then(() => {
        this.loading = false
      })
      .catch((error) => {
        this.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      })
  },
  methods: {
    ...mapActions({
      fetchRightsGroup: 'rightsGroup/fetchRightsGroup',
      fetchHardwaresGroup: 'hardwaresGroup/fetchHardwaresGroup',
      fetchEmployeesGroup: 'employeesGroup/fetchEmployeesGroup',
      fetchTimezones: 'timezone/fetchTimezones',
    }),
    customFilter(value, search, item) {
      return (
        item.title_th?.toLowerCase().includes(search.toLowerCase()) ||
        item.title_en?.toLowerCase().includes(search.toLowerCase()) ||
        item.hardware_group?.title_th
          ?.toLowerCase()
          .includes(search.toLowerCase()) ||
        item.employee_group?.title_th
          ?.toLowerCase()
          .includes(search.toLowerCase()) ||
        item.timezone?.timezone_code?.includes(search.toLowerCase()) ||
        item.timezone?.title_th?.toLowerCase().includes(search.toLowerCase())
      )
    },
    classRowSelected(row) {
      if (this.rightGroup.authority_uuid === row.authority_uuid)
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::authority:get')) {
        this.dialogForbidden = true
        return
      }

      if (this.rightGroup.authority_uuid === row.authority_uuid) {
        this.rightGroupFormShow = false
        this.rightGroupFormAction = ''
        this.rightGroup = {}
        this.rightGroupInit = {}
      } else {
        this.rightGroupFormShow = true
        this.rightGroupFormAction = 'edit'
        this.rightGroup = {
          ...row,
          hardware_group_uuid: row.hardware_group?.hardware_group_uuid,
          employee_group_uuid: row.employee_group?.employee_group_uuid,
          timezone_uuid: row.timezone?.timezone_uuid,
          access_control_date_start: row.access_control_start_time
            ? moment.utc(row.access_control_start_time).format('YYYY-MM-DD')
            : '',
          access_control_time_start: row.access_control_start_time
            ? moment.utc(row.access_control_start_time).format('HH:mm')
            : '',
          access_control_date_expire: row.access_control_end_time
            ? moment.utc(row.access_control_end_time).format('YYYY-MM-DD')
            : '',
          access_control_time_expire: row.access_control_end_time
            ? moment.utc(row.access_control_end_time).format('HH:mm')
            : '',
        }
        this.rightGroupInit = {
          ...row,
          hardware_group_uuid: row.hardware_group?.hardware_group_uuid,
          employee_group_uuid: row.employee_group?.employee_group_uuid,
          timezone_uuid: row.timezone?.timezone_uuid,
          access_control_date_start: row.access_control_start_time
            ? moment.utc(row.access_control_start_time).format('YYYY-MM-DD')
            : '',
          access_control_time_start: row.access_control_start_time
            ? moment.utc(row.access_control_start_time).format('HH:mm')
            : '',
          access_control_date_expire: row.access_control_end_time
            ? moment.utc(row.access_control_end_time).format('YYYY-MM-DD')
            : '',
          access_control_time_expire: row.access_control_end_time
            ? moment.utc(row.access_control_end_time).format('HH:mm')
            : '',
        }
      }
    },
    handleRowSelected(row) {
      if (this.isRightGroupDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddRightsGroupForm() {
      this.rightGroupFormShow = true
      this.rightGroupFormAction = 'add'
      this.rightGroup = {}
      this.rightGroupInit = {}
    },
    handleRightGroupFormDataChange(value) {
      this.isRightGroupDataChange = value
    },
    handleRightGroupFormReset(formAction) {
      if (formAction === 'edit') {
        this.rightGroup = { ...this.rightGroupInit }
      }
    },
    handleRightGroupFormActionCompleted(formAction) {
      // if (formAction === 'edit') {
      //   this.rightGroup = {}
      //   this.rightGroupInit = {}
      // }
      this.rightGroup = {}
      this.rightGroupInit = {}
      this.rightGroupFormShow = false
      this.rightGroupFormAction = ''
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.rightGroupFormShow = false
      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isRightGroupDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
